import React from 'react';
import PropTypes from 'prop-types';
import { PRODUCT_TYPES } from '@utils/enums';
import CartItem from '@components/cart/receipt/CartItem';
import CartPairCare from '@components/cart/receipt/CartPairCare';
import RxChoices from '@components/cart/rx/RxChoices';
import Upsell from '@components/cart/receipt/Upsell';

const CartItemsBundle = ({ item, hasPairCare, rxType, baseItemGroupKey, pairCareKey, nonRxGroup, onDeleteBaseFrame, minicart }) => {
	const isPairCare = item.sku ? item.sku.includes('PAIR_CARE') : false;
	if (isPairCare) {
		return null;
	}

	let itemNode = null;
	let pairCareNode = null;
	let rxChoicesNode = null;
	let upsellNode = null;

	const isBaseFrame = item.product_type.includes(PRODUCT_TYPES.BASE_FRAME);
	const isLens = item.product_type.includes(PRODUCT_TYPES.LENS);

	if (!item.upsell && !isPairCare) {
		itemNode = (
			<CartItem
				item={item}
				isBaseFrame={isBaseFrame}
				isLens={isLens}
				image={item.image}
				rxType={rxType}
				itemGroupKey={baseItemGroupKey}
				quantity={item.quantity}
				onDeleteBaseFrame={onDeleteBaseFrame}
				minicart={minicart}
			/>
		);
	}

	if (isBaseFrame) {
		// render if pair care too!!
		const pairCareProductDescription = '1-year warranty that covers scratched lenses or damaged frames';
		pairCareNode = (
			<CartPairCare
				bundleKey={baseItemGroupKey}
				hasPairCare={hasPairCare}
				pairCareKey={pairCareKey}
				addInfo={pairCareProductDescription}
				insuredBaseFrame={item.id}
			/>
		);

		if (rxType === 'Readers') {
			rxChoicesNode = (
				<RxChoices
					rxType='readers'
					item={item}
					bundleKey={baseItemGroupKey}
					readerStrength={item.properties._readerStrength}
				/>
			);
		} else if (rxType === 'Non-Prescription') {
			rxChoicesNode = null;
		} else {
			rxChoicesNode = <RxChoices item={item} bundleKey={baseItemGroupKey} />;
		}
	}

	if (item.upsell) {
		const upsellCopy = `The most popular top for The ${item.title}!`;
		upsellNode = (
			<Upsell
				bundleKey={baseItemGroupKey}
				addInfo={upsellCopy}
				itemGroupKey={baseItemGroupKey}
				nonRxGroup={nonRxGroup}
				lozengeMessage='Top Rated'
				recommendation={item}
				minicart={minicart}
			/>
		);
	}

	return (
		<>
			{itemNode}
			{pairCareNode}
			{rxChoicesNode}
			{upsellNode}
		</>
	);
};

CartItemsBundle.propTypes = {
	item: PropTypes.shape({}).isRequired,
	hasPairCare: PropTypes.bool,
	nonRxGroup: PropTypes.bool,
	minicart: PropTypes.bool,
	rxType: PropTypes.string,
	baseItemGroupKey: PropTypes.string,
	pairCareKey: PropTypes.string,
	onDeleteBaseFrame: PropTypes.func.isRequired,
};

export default CartItemsBundle;
